import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { UserAccount } from '../../../../objects';
import { EditUserComponent } from 'app/modules/admin/components/edit-user/edit-user.component';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit {

  public data: UserAccount[];

    constructor(
      public dialog: MatDialog,
      private apiSvc: ApiService
    ) { }

  ngOnInit() {
    this.loadElements();
  }

  private loadElements() {
    this.apiSvc.get("api/UserAccount", null).subscribe(
      (data: UserAccount[]) => {
        this.data = data;
        console.log(this.data);
      },
      (err) => {
        console.log("error", err);
      }
    );
  }

  public add() {

    var modal = this.dialog.open(EditUserComponent);

    var user = new UserAccount();
    user.IsActive = true;
    user.RoleId = 1; 

    modal.componentInstance.setUser(user);

    modal.afterClosed().subscribe((savedUser: UserAccount) => {
      console.log("modal closed", savedUser);
      if (savedUser !== undefined) { 
        this.loadElements();
      }
    });

  }

  public edit(obj: UserAccount) {

    var modal = this.dialog.open(EditUserComponent);
    modal.componentInstance.setUser(obj);

    modal.afterClosed().subscribe((savedUser: UserAccount) => {
      console.log("modal closed", savedUser);
      if (savedUser !== undefined) {
        this.loadElements();
      }
    });


  }


  public approveRegistration(obj: UserAccount) {

     obj.RegistrationStatusId  = 1;

    var response = this.apiSvc.post<any>("api/UserAccount/Save", obj);

          response.subscribe(
              data => {
                console.log(data);
                this.loadElements();
              },
              err => {
                console.log(err);
              }
          );
  }

  public delete(obj) {
    //
  }

}
